const translations = {
  "en": {
    "Amount": "Amount",
    "Date": "Date",
    "No Data Yet": "No Data Yet",
    "Payment History No Data": "Payment History No Data",
    "Payment Method": "Payment Method",
    "Plan": "Plan"
  },
  "zh-tw": {
    "Amount": "金額",
    "Date": "日期",
    "No Data Yet": "暫無資料",
    "Payment History No Data": "暫無付款紀錄",
    "Payment Method": "付款方式",
    "Plan": "方案"
  }
};

export default translations;
